import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRight } from 'lucide-react';
interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  imageAlt: string;
  date: string;
  url: string;
}
const BlogsPage = () => {
  const blogPosts: BlogPost[] = [{
    id: 'pass-first-time',
    title: 'How to Pass Your Driving Test First Time in Northampton',
    excerpt: "Passing your driving test first time is every learner's goal. At Northampton Driving School, our automatic lessons and expert instructors give you the best chance of success.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7Eicwv6ks6eYjm4cF95PHU/automatic_cars.jpg',
    imageAlt: 'Student celebrating passing driving test first time in Northampton with certificate',
    date: 'June 15, 2023',
    url: '/blogs/pass-first-time'
  }, {
    id: 'automatic-driving-lessons',
    title: 'Why Automatic Driving Lessons Are the Best Choice in Northampton',
    excerpt: 'Automatic cars are becoming more popular, and many learners in Northampton are choosing automatic lessons to pass faster and with less stress.',
    image: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    imageAlt: 'Automatic gear selector in modern car used for driving lessons in Northampton',
    date: 'July 8, 2023',
    url: '/blogs/automatic-driving-lessons'
  }, {
    id: 'intensive-driving-courses',
    title: 'Intensive Driving Courses in Northampton – Are They Right for You?',
    excerpt: "If you want to pass quickly, intensive driving courses in Northampton could be the right choice. Let's explore the benefits and who they're best for.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bgzF4LtUEMbcnNcgQLV5X3/intensive.jpg',
    imageAlt: 'Focused learner taking intensive driving course in Northampton with instructor',
    date: 'August 22, 2023',
    url: '/blogs/intensive-driving-courses'
  }, {
    id: 'nervous-drivers-tips',
    title: 'Top 5 Tips for Nervous Drivers in Northampton',
    excerpt: 'Many learners feel nervous when starting driving lessons. At Northampton Driving School, we specialise in helping nervous drivers in Northampton feel comfortable and confident.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xcReQjNt2bZTa9FggJQLWX/Nervouse_Driver.jpg',
    imageAlt: 'Nervous learner driver being supported by patient instructor in Northampton',
    date: 'September 5, 2023',
    url: '/blogs/nervous-drivers-tips'
  }];
  return <div className="bg-white" data-id="element-1051">
      <Helmet data-id="element-1052">
        <title data-id="element-1053">
          Driving Lessons Blog | Northampton Driving School Tips & Advice
        </title>
        <meta name="description" content="Expert driving tips, advice for nervous drivers, and guides to passing your test first time in Northampton. Learn from our DVSA-approved instructors." data-id="element-1054" />
        <meta name="keywords" content="driving lessons blog, Northampton driving tips, automatic driving lessons advice, nervous driver help, intensive driving courses Northampton, pass driving test first time" data-id="element-1055" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1056">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1057">
          Driving Lessons Blog
        </h1>
        <h2 className="sr-only" data-id="element-1058">
          Automatic Driving Lessons Tips & Advice Northampton
        </h2>
        <h2 className="sr-only" data-id="element-1059">
          Expert Driving Instruction Guides Northampton
        </h2>
        <p className="text-gray-700 mb-8 max-w-3xl" data-id="element-1060">
          Welcome to our driving blog, where our DVSA-approved instructors share
          expert tips and advice to help you become a confident, skilled driver.
          From passing your test first time to overcoming driving anxiety, we've
          got you covered.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8" data-id="element-1061">
          {blogPosts.map(post => <article key={post.id} className="bg-white rounded-lg overflow-hidden shadow-md border border-gray-200 flex flex-col h-full" data-id="element-1062">
              <Link to={post.url} aria-label={`View article about ${post.title}`} data-id="element-1063">
                <img src={post.image} alt={post.imageAlt} className="w-full h-56 object-cover hover:opacity-90 transition-opacity" loading="lazy" data-id="element-1064" />
              </Link>
              <div className="p-6 flex flex-col flex-grow" data-id="element-1065">
                <span className="text-sm text-gray-500 mb-2" data-id="element-1066">{post.date}</span>
                <h2 className="text-xl font-bold mb-3 hover:text-burgundy-600 transition-colors" data-id="element-1067">
                  <Link to={post.url} data-id="element-1068">{post.title}</Link>
                </h2>
                <p className="text-gray-700 mb-4 flex-grow" data-id="element-1069">{post.excerpt}</p>
                <Link to={post.url} className="text-burgundy-600 hover:text-burgundy-800 font-medium inline-flex items-center mt-auto" aria-label={`Read more about ${post.title}`} data-id="element-1070">
                  Read More <ArrowRight size={16} className="ml-1" data-id="element-1071" />
                </Link>
              </div>
            </article>)}
        </div>
      </div>
    </div>;
};
export default BlogsPage;